import 'swiper/css';
import 'swiper/css/pagination';
import { MobileHeader } from 'src/pages/BonusGame/components/Header';
import { PageWrapper } from '../../ui/common';
import { VerticalView } from 'src/components/FlexViews';
import styled from 'styled-components';
import { useEffect, useRef, useState } from 'react';

import { Navigation, Pagination } from 'swiper/modules';
import { Swiper, SwiperClass, SwiperSlide } from 'swiper/react';
import { useUserContext } from '../../contexts/UserContext';
import { TreeItem } from './components/TreeItem';

import treeItem1 from 'src/assets/img/bonus-game/trees/tree-1.webp';
import treeItem2 from 'src/assets/img/bonus-game/trees/tree-2.webp';
import treeItem3 from 'src/assets/img/bonus-game/trees/tree-3.webp';
import treeItem4 from 'src/assets/img/bonus-game/trees/tree-4.webp';
import treeItem5 from 'src/assets/img/bonus-game/trees/tree-5.webp';
import treeItem6 from 'src/assets/img/bonus-game/trees/tree-6.webp';
import treeItem7 from 'src/assets/img/bonus-game/trees/tree-7.webp';
import treeItem8 from 'src/assets/img/bonus-game/trees/tree-8.webp';
import treeItem9 from 'src/assets/img/bonus-game/trees/tree-9.webp';
import treeItem10 from 'src/assets/img/bonus-game/trees/tree-10.webp';
import { bonusGameApi } from 'src/api/bonus-game';
import { positions } from '../../contexts/constants';

const ErrorText = styled.p`
  color: #f44336;
  font-size: 12px;
  margin: 4px 0 0;
  text-align: center;
  height: 30px;
`;

const SwiperWrapper = styled.div`
  .swiper {
    width: 100%;
    height: 350px;
  }

  .swiper-wrapper {
    height: calc(100% - 8px);
  }

  .swiper-slide {
    width: 100%;
    padding: 0 10px;
  }

  .swiper-pagination {
    position: relative;
    top: -76px;
  }

  .swiper-pagination-bullet {
    width: 6px;
    height: 6px;
    border-radius: 50%;
    background-color: rgba(255, 255, 255, 0.2);
  }

  .swiper-pagination-bullet-active {
    width: 6px;
    height: 6px;
    background-color: #fff;
  }
`;

const TreeNameInput = styled.input`
  border: none;
  border-radius: 12px;
  background: rgba(143, 150, 163, 0.1);
  padding: 10px 16px;
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;
  text-align: center;
  color: #fff;

  &:focus {
    outline: none;
    border: 1px solid rgba(143, 150, 163, 0.7);
  }
`;

const trees = [
  {
    src: treeItem1,
    coinsPositions: positions[0],
  },
  {
    src: treeItem2,
    coinsPositions: positions[1],
  },
  {
    src: treeItem3,
    coinsPositions: positions[2],
  },
  {
    src: treeItem4,
    coinsPositions: positions[3],
    isReached: '2 500',
    isReachedNumber: 2500,
  },
  {
    src: treeItem5,
    coinsPositions: positions[4],
    isReached: '5 000',
    isReachedNumber: 5000,
  },
  {
    src: treeItem6,
    coinsPositions: positions[5],
    isReached: '10 000',
    isReachedNumber: 10000,
  },
  {
    src: treeItem7,
    coinsPositions: positions[6],
    isReached: '25 000',
    isReachedNumber: 25000,
  },
  {
    src: treeItem8,
    coinsPositions: positions[7],
    isReached: '50 000',
    isReachedNumber: 50000,
  },
  {
    src: treeItem9,
    coinsPositions: positions[8],
    isReached: '100 000',
    isReachedNumber: 100000,
  },
  {
    src: treeItem10,
    coinsPositions: positions[9],
    isReached: '150 000',
    isReachedNumber: 150000,
  },
];

export const EditTree = () => {
  const [errorText, setErrorText] = useState('');
  const [isEditing, setIsEditing] = useState(false);
  const [text, setText] = useState('');
  const { gameStat, selectredTree, setSelectedTree, setGameStat } =
    useUserContext();
  const swiperRef = useRef<SwiperClass | null>(null);

  const handleClickNext = () => {
    if (swiperRef.current) {
      swiperRef.current.slideNext();
    }
  };

  const handleClickPrev = () => {
    if (swiperRef.current) {
      swiperRef.current.slidePrev();
    }
  };

  useEffect(() => {
    setText(gameStat?.bonusTreeName ?? '');
  }, [gameStat?.bonusTreeName]);

  const handleToggleEdit = () => {
    setErrorText('');
    setIsEditing(!isEditing);
  };

  const handleInputChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setText(event.target.value);
  };
  const handleInputBlur = async () => {
    setIsEditing(false);

    if (text === gameStat?.bonusTreeName) {
      return;
    }

    if (text.includes('BonusTree')) {
      setErrorText(
        "Your name cannot include 'BonusTree'. Please choose a different name",
      );
      setText(gameStat?.bonusTreeName);
      return;
    }

    try {
      const changeNameRes = await bonusGameApi.changeFeatures({ name: text });
      if (changeNameRes?.result) {
        setGameStat({ ...gameStat, bonusTreeName: text });
      } else {
        setText(gameStat?.bonusTreeName);
      }
    } catch (e: any) {
      setText(gameStat?.bonusTreeName);
      setErrorText(e.response.data.message);
      console.error(e);
    }
  };

  return (
    <PageWrapper>
      <MobileHeader title="Edit Tree" />
      <VerticalView style={{ width: '100%' }}>
        <TreeNameInput
          value={text}
          onChange={handleInputChange}
          onBlur={handleInputBlur}
        />

        <ErrorText>{errorText}</ErrorText>
      </VerticalView>
      <SwiperWrapper>
        <Swiper
          onSwiper={(swiper: any) => {
            swiperRef.current = swiper;
          }}
          navigation
          slidesPerView={'auto'}
          pagination={{
            clickable: true,
          }}
          modules={[Pagination, Navigation]}>
          {trees.map((tree, index) => (
            <SwiperSlide key={index}>
              <TreeItem
                isActive={
                  !tree.isReached ||
                  Number(tree.isReachedNumber) <= Number(gameStat.rating)
                }
                needToReach={tree.isReached}
                coins={tree.coinsPositions}
                imgSrc={tree.src}
                selected={selectredTree.path === tree.src}
                handleClickNext={handleClickNext}
                handleClickPrev={handleClickPrev}
                onApply={(treePath: string) => {
                  if (selectredTree.path === tree.src) return;
                  bonusGameApi.changeFeatures({ view: String(index) });
                  setSelectedTree({
                    positions: tree.coinsPositions,
                    path: treePath,
                  });
                }}
              />
            </SwiperSlide>
          ))}
        </Swiper>
      </SwiperWrapper>
    </PageWrapper>
  );
};
